export default __webpack_public_path__ + "static/media/Review 3.34c158a5.png";